export const contactInformation = {
    name: "Shubham Soni",
    email: "shubham.soni@rhdhv.com",
    phone: "+31613520111",
};
